// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"Icons_iconContainer__1x-ue"};